export const BLUE_LIGHT_COLOR = '#AAD6FF';
export const BLUE_DARK_COLOR = '#141B4A';
